export const environment = {
  name: 'staging',
  production: false,
  uat: false,
  staging: true,
  development: false,
  baseUrl: 'https://stg-yvw-api.tracwater.online', // Sensorwise Develop Server
  portalId: '66e8fb0b2dd5edde86407569',
  portalTypeId: '6895970418f8a8985a2aebe2'
};
